import React from 'react'
import { Container, Card } from 'react-bootstrap'
import CardSectionBlock from './cardSectionBlock'
import styled from '@emotion/styled'
import { IChecklistCardProps } from './proposalInterfaces/cardChecklistCardProps'

const ChecklistCard = (props: IChecklistCardProps) => {
  const cardHasErrors = !!props.errorList.find(
    (err) => err.cardNumber === props.data.cardNumber
  )

  let headerStyle = {
    backgroundColor: cardHasErrors ? '#b33834' : '#d14200',
    color: '#f7f7f7',
  }

  return (
    <div>
      <Container className="section mt-4">
        <CustomCard
          className="mb-13rem card-shadow"
          style={{ borderColor: headerStyle.backgroundColor }}
        >
          <Card.Header
            className="border-bottom-0"
            style={headerStyle}
            id={props.id}
          >
            <div className="text-header">
              {props.headingNumber}. {props.data.title}
            </div>
          </Card.Header>
          <Card.Body>
            {props.data.prefix}
            {props.data.datablocks.map((sb) => (
              <CardSectionBlock
                cardNumber={props.data.cardNumber}
                sectionBlock={sb}
                UpdateChecked={props.UpdateChecked}
                errorList={props.errorList}
                theme={props.theme}
              />
            ))}
            {props.data.suffix}
          </Card.Body>
        </CustomCard>
      </Container>
    </div>
  )
}

export default ChecklistCard

const CustomCard = styled(Card)`
  label: CustomCard;
  border-color: ${(props) => props.borderColor};
`
